import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import ContactPage from '../pages/contact/page';
import ConditionsGeneralesPage from '../pages/conditions-generales/page';
import PolitiqueConfidentialitePage from '../pages/politique-confidentialite/page';
import InformationsEntreprisePage from '../pages/informations-entreprise/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/a-propos',
    element: <AboutPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/conditions-generales',
    element: <ConditionsGeneralesPage />,
  },
  {
    path: '/politique-confidentialite',
    element: <PolitiqueConfidentialitePage />,
  },
  {
    path: '/informations-entreprise',
    element: <InformationsEntreprisePage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
